
import CreateModal from '@/components/create-modal';
import ActivityDetailModal from '@/components/activity-detail-modal';
import ModuleNavigation from '@/components/module-navigation';
import { moduleDefinitionsQueryOptions } from '@/queries/moduleDefinitionsQueryOptions';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Toaster } from '@/components/ui/sonner';
import devExpressConfig from 'devextreme/core/config';
devExpressConfig({ licenseKey: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjVjMzJmMjNmLWVmNzMtNDZkNi1hMWZjLTQ1NDIzOTNjMDJiYyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.Be+Ev75I8ZPMLHz4GRCfh1/n2EX4jpzTbg8O7y8dgybw5tLAAid57ODB+WYhf91jxfzIzVYTUG3ely4bAwGpeQpbyfPqQ3Hz+bkpqKfYkk0ii1xZ0opmDZdZUJOvgq5vbEroBg==' })
import 'devextreme/dist/css/dx.light.css';

export const Route = createFileRoute('/_app')({
    component: RouteComponent,
    beforeLoad: ({ context }) => {
        if (!context.auth.isAuthenticated) {
            throw redirect({ to: '/sign-in' })
        }
    },
    loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(moduleDefinitionsQueryOptions)
})

function RouteComponent() {

    return <div className='h-full'>
        <div className='flex h-full w-full flex-row'>
            <ModuleNavigation />
            <Outlet />
        </div>
        <CreateModal />
        <ActivityDetailModal />
        <Toaster />
    </div>
}
